import classes from './IconGrid.module.scss'

import gridDesktop from './iconGridDesktop.svg'
import gridMobile from './iconGridMobile.svg'
import gridMobileSm from './iconGridMobileSM.svg'

export const IconGrid = () => {

    return (
        <div className={`${classes.container}`}>
            <img className={classes.desktop} src={gridDesktop} alt='Icons grid'/>
            <img className={classes.mobile} src={gridMobile} alt='Icons grid'/>
            <img className={classes['mobile-sm']} src={gridMobileSm} alt='Icons grid'/>
        </div>
    )
}
